// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"c739666b","448":"d425dd60","821":"9ea213a7","886":"bd50e545","977":"e5003aec"}[chunkId] + ".chunk.js";
};